if (!customElements.get('order-tracker-drawer')) {
    customElements.define(
        'order-tracker-drawer',
        class OrderTrackerDrawer extends HTMLElement {
            connectedCallback() {
                this.activeClass = 'order-tracker-drawer--open';
                this.closeBlocked = false;
                this.overlay = this.querySelector('.order-tracker-drawer__overlay');
                this.titleEl = this.querySelector('.order-tracker-drawer__title');
                this.contentEl = this.querySelector('.order-tracker-drawer__content-inner');
                this.closeButton = this.querySelector('.order-tracker-drawer__close');
                this.footerEl = this.querySelector('.order-tracker-drawer__footer');

                this.closeButton?.addEventListener('click', () => this.close());
                this.overlay?.addEventListener('click', () => this.close());

                this.delegatedClickHandler = (e) => {
                    const btn = e.target.closest('.shipment__item-link[data-replacement-id]');
                    if (btn) {
                        e.preventDefault();
                        this.openFromReplacementButton(btn);
                    }
                };
                document.addEventListener('click', this.delegatedClickHandler);

                this.escapeHandler = (e) => {
                    if (e.key === 'Escape' && this.classList.contains(this.activeClass)) {
                        this.close();
                    }
                };
                document.addEventListener('keydown', this.escapeHandler);
            }

            disconnectedCallback() {
                document.removeEventListener('click', this.delegatedClickHandler);
                document.removeEventListener('keydown', this.escapeHandler);
            }

            setCloseBlocked(blocked) {
                this.closeBlocked = Boolean(blocked);
                this.classList.toggle('order-tracker-drawer--close-blocked', this.closeBlocked);
                if (this.closeButton) {
                    this.closeButton.disabled = this.closeBlocked;
                    this.closeButton.setAttribute('aria-disabled', this.closeBlocked ? 'true' : 'false');
                }
                return this;
            }

            /**
             * @param {string|null} html
             * @returns {this}
             */
            footerHtml(html) {
                if (!this.footerEl) return this;

                if (html == null || html === '') {
                    this.footerEl.innerHTML = '';
                    this.footerEl.hidden = true;
                    this.classList.remove('order-tracker-drawer--has-footer');
                } else {
                    this.footerEl.innerHTML = html;
                    this.footerEl.hidden = false;
                    this.classList.add('order-tracker-drawer--has-footer');
                }

                return this;
            }

            /**
             * @param {{ title?: string, html?: string, footerHtml?: string|null, sourceSelector?: string }} options
             * @returns {boolean} Whether the drawer opened
             */
            open(options = {}) {
                const { title = '', html = null, footerHtml = null, sourceSelector = null } = options;

                let body = html;
                if (sourceSelector) {
                    const src = document.querySelector(sourceSelector);
                    body = src ? src.innerHTML : null;
                }

                if (body == null || body === '') {
                    return false;
                }

                if (this.titleEl) {
                    this.titleEl.textContent = title ? title.charAt(0).toUpperCase() + title.slice(1) : '';
                }

                if (this.contentEl) {
                    this.contentEl.innerHTML = body;
                }

                this.footerHtml(footerHtml);
                this.setCloseBlocked(false);

                this.classList.add(this.activeClass);
                document.body.classList.add('drawer-open');
                return true;
            }

            openFromReplacementButton(btn) {
                const replacementId = btn.dataset.replacementId;
                if (!replacementId) return;

                const title = btn.dataset.title || '';
                const sourceEl = document.querySelector(
                    `.shipment__item-replacements__drawer-content[data-replacement-id="${replacementId}"]`
                );
                if (!sourceEl) return;

                this.open({
                    title,
                    html: sourceEl.innerHTML,
                });
            }

            close() {
                if (this.closeBlocked) return;
                if (!this.classList.contains(this.activeClass)) return;

                this.classList.remove(this.activeClass);
                document.body.classList.remove('drawer-open');
                if (this.contentEl) {
                    this.contentEl.innerHTML = '';
                }
                this.footerHtml('');
                this.dispatchEvent(new CustomEvent('order-tracker-drawer:closed', { bubbles: true }));
            }
        }
    );
}
